import columnsResizable from './columnsResizable.js';
export default {
  install(Vue) {
    Vue.directive(columnsResizable.name, columnsResizable);
  },
};
